export default __webpack_public_path__ + "static/media/Mask Group 31@2x.9d88770a.png";